import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbDate, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../Model/Common/common.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { SessionService } from '../../Util/Session/session.service';
import { Router, RouterModule } from '@angular/router';
import { LeaveService } from '../../Model/Leave/leave.service';
import { CalendarService } from '../../Model/Calendar/calendar.service';
import { AttendanceService } from '../../Model/Attendance/attendance.service';
import { PayslipService } from '../../Model/Payslip/payslip.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { FeedService } from '../../Model/Feeds/feed.service';
import { HolidayService } from '../../Model/Holiday/holiday.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { CompensatoryOffService } from '../../Model/CompensatoryOff/compensatory-off.service';
import { LoginService } from '../../Model/Login/login.service';
import moment from 'moment';
import { MPINDialogComponent } from '../../Component/mpindialog/mpindialog.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgChartsModule } from 'ng2-charts';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-attendanceview',
  standalone: true,
  imports: [CommonModule, NgChartsModule, FormsModule, NgbDatepickerModule, RouterModule, LoaderComponent],
  templateUrl: './attendanceview.component.html',
  styleUrl: './attendanceview.component.scss'
})
export class AttendanceviewComponent {
  @Input() InputData: any;
  isDisabled: boolean = false;
  ToDayDate = null as any;
  user = [] as any;
  Duration: string = '0h 0m 0s';
  filter = {
    AttendanceDate: null as any
  }
  AttendanceDetail = {
    EmpMasterId: null,
    EmployeeName: null,
    EmpType: null,
    DesignationID: null,
    DesignationName: null,
    DutyID: null,
    DutyName: null,
    BranchID: null,
    BranchName: null,
    SiteID: null,
    SiteName: null,
    ShiftMasterID: null,
    ShiftTitle: null,
    AttendanceDate: null as any,
    InTime: null as any,
    OutTime: null as any,
    WorkingHour: null,
    AttendanceStatus: null,
    AttendanceStatusOut: null,
    AttendanceRemark: null,
    AttendanceRemarkOut: null,
    DailyAttendancePhoto: null,
    DailyAttendancePhotoOut: null,
    OpenMonth: null,
    OpenYear: null,
    BiometricAttendanceId: null,
    IsManual: null,
    AttendanceMatchPercentage: null,
    Latitude: null,
    Longitude: null,
    Altitude: null,
    NearByLocationName: null,
    BillableOT: null,
    NonBillableOT: null,
    RegularizationID_IN: null,
    RegularizationID_OUT: null,
    LeaveID: null,
    AttendanceDescription: null,
    ApprovalStatus: null,
    GeoTagged: null,
    MobileName: null,
    AccessCard: null,
    MobileId: null,
    Address: null,
    Remark: null,
    NearByLocationName1: null,
    IsOtherDuty: null,
    WebCheckInOut: null,
    MobileCheckInOut: null,
    GeoTagging: null,
    SiteQRCodeScanning: null,
    EmployeeQRCodeScanning: null,
    Selfie: null,
    SelfieType: null,
    EmployeeNotCheckIn: null,
    IsOtherDuty1: null,
    IsAttendanceAll: null,
    RestrictIP: null,
    IP: null,
    AttendanceType: null,
    Duration: null,
    HalfDayDuration: null,
    OTApplicable: null,
    OTApplicableIn: null,
    FirstCheckInLate: null,
    LastCheckOutEarly: null,
    Deviation: null,
    DeviationMoreThan: null,
    DeviationMoreThanPeriod: null,
    DeviationOccurMultiplyOf: null,
    DeviationOccurMultiplyOFPeriod: null,
    LeaveDeductDay: null,
    LeaveDeductType: null,
    ShiftMargin: null,
    HourBeforeShiftStart: null,
    HourAfterShiftStart: null,
    Insentive: null,
    AttendanceGreaterThan: null,
    AttendanceOccurMultiplyOf: null,
    AttendanceOccurMultiplyOfPeriod: null,
    IsCheckIn: false,
    IsAttendaceClose: false,
    SelectType: 'InsertUpdate',
  };
  calendarDataSummary: any[] = [];
  CalendarDetailsData = {
    id: 0,
    Photo: null as any,
    EmployeeName: '',
    EmpCode: null,
    DesignationName: null,
    AttendanceDate: null as any,
    InTime: null,
    OutTime: null,
    ShiftTitle: null,
    Remark: null,
    DailyAttendancePhoto: null,
    DailyAttendancePhotoOut: null,
    InReason: null,
    OutReason: null,
    AttendanceDescription: null,
  }
  calendarData: any[] = [];
  constructor(
    public activeModal: NgbActiveModal,
    private utility: UtilityService,
    private session: SessionService,
    protected common: CommonService,
    protected dateFromat: CustomDateParserFormatter,
    private modalService: NgbModal,
    private attendance: AttendanceService,
    private toast: ToastService,
    private Calendar: CalendarService,
  ) {
    this.ToDayDate = this.dateFromat.parse(moment(Date()).format("DD MMM YYYY"));
    this.common.CompanyParameter();
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    //
    if (this.user.IsPopFirstTimeMpin) {
      //this.ESS_GetLoginDetails(true);
    }
  }
  ngOnInit() {
    this.AttendanceDetail.EmpMasterId = this.InputData.EmpmasterID;
    this.SelectDate('RegistrationDate', null, null);
  }
  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.ToDayDate = this.dateFromat.parse(response.Table[0].RegistrationDate);
        }
        //this.LoadBirthdayDetails();

        this.GetCalendar(this.dateFromat.fullmonth[this.ToDayDate.month - 1], this.ToDayDate.year);
        this.ESS_GetESSAttendanceSummaryWeb(this.dateFromat.fullmonth[this.ToDayDate.month - 1], this.ToDayDate.year);
        this.isDisabled = false;
      },
      complete: () => {
        this.GetDailyAttendanceInOut();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  onNavigate(event: any) {
    this.GetCalendar(this.dateFromat.fullmonth[event.next.month - 1], event.next.year);
    this.ESS_GetESSAttendanceSummaryWeb(this.dateFromat.fullmonth[event.next.month - 1], event.next.year);
  }

  GetCalendar(Month: String, Year: String) {
    this.Calendar.GetAttendanceCalendar({ MonthName: Month, YearName: Year, EmpMasterId: this.InputData.EmpmasterID, }).subscribe({
      next: (response) => {
        this.calendarData = response;
        if (this.filter.AttendanceDate == null) {
          this.filter.AttendanceDate = this.dateFromat.parse(moment(Date()).add({ day: -1 }).format("DD MMM YYYY"));
        }

        if (this.calendarData.filter(e => this.dateFromat.format(this.dateFromat.parse(moment(e.AttendanceDate).format("DD MMM YYYY"))) == this.dateFromat.format(this.dateFromat.parse(moment(this.dateFromat.format(this.filter.AttendanceDate)).format("DD MMM YYYY")))).length > 0) {
          this.GetDailyAttendanceInOutDetail(this.calendarData.filter(e => this.dateFromat.format(this.dateFromat.parse(moment(e.AttendanceDate).format("DD MMM YYYY"))) == this.dateFromat.format(this.dateFromat.parse(moment(this.dateFromat.format(this.filter.AttendanceDate)).format("DD MMM YYYY"))))[0].DailyAttendanceInOutID);
        } else {
          this.GetDailyAttendanceInOutDetail(0);
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }
  CalenderDateSelect(event: any) {
    if (this.calendarData.filter(e => this.dateFromat.format(this.dateFromat.parse(moment(e.AttendanceDate).format("DD MMM YYYY"))) == this.dateFromat.format(event)).length > 0) {
      this.GetDailyAttendanceInOutDetail(this.calendarData.filter(e => this.dateFromat.format(this.dateFromat.parse(moment(e.AttendanceDate).format("DD MMM YYYY"))) == this.dateFromat.format(event))[0].DailyAttendanceInOutID);
    } else {
      this.CalendarDetailsData.id = 0;
      this.CalendarDetailsData.Photo = this.InputData.Photo;
      this.CalendarDetailsData.EmployeeName = this.InputData.EmpName;
      this.CalendarDetailsData.EmpCode = this.InputData.EmpCode;
      this.CalendarDetailsData.DesignationName = this.InputData.DesignationName;
      this.CalendarDetailsData.AttendanceDate = this.filter.AttendanceDate;
      this.CalendarDetailsData.InTime = null;
      this.CalendarDetailsData.OutTime = null;
      this.CalendarDetailsData.ShiftTitle = null;
      this.CalendarDetailsData.Remark = null;
      this.CalendarDetailsData.DailyAttendancePhoto = null;
      this.CalendarDetailsData.DailyAttendancePhotoOut = null;
      this.CalendarDetailsData.InReason = null;
      this.CalendarDetailsData.OutReason = null;
      this.CalendarDetailsData.AttendanceDescription = null;
    }
  }
  ESS_GetESSAttendanceSummaryWeb(Month: String, Year: String) {debugger
    this.calendarDataSummary = [];
    this.Calendar.ESS_GetESSAttendanceSummaryWeb({ MonthName: Month, YearName: Year, EmpMasterID: this.InputData.EmpmasterID, }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          console.log(response.Table);
          this.calendarDataSummary = response.Table;
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }
  // CheckIn() {
  //   //if (this.AttendanceDetail.WebCheckInOut) {
  //   if (!this.AttendanceDetail.IsCheckIn) {
  //     this.AttendanceDetail.IsCheckIn = true;
  //     this.AttendanceDetail.InTime = this.CurrentTime;
  //     this.getIPAddress()
  //   }
  //   // } else {
  //   //   this.toast.show({ message: "Web attendance not allowed", type: toastTypeEnum.danger });
  //   // }
  // }

  // CheckOut() {
  //   if (this.AttendanceDetail.WebCheckInOut) {
  //     if (this.AttendanceDetail.IsCheckIn) {
  //       this.AttendanceDetail.IsCheckIn = false;
  //       clearInterval(this.IntervalId);
  //       this.IntervalId = null;
  //       this.AttendanceDetail.OutTime = this.CurrentTime;
  //       this.getIPAddress();
  //     }
  //   } else {
  //     this.toast.show({ message: "Web attendance not allowed", type: toastTypeEnum.danger });
  //   }
  // }

  GetDateTime(IsAction: boolean) {
    this.isDisabled = true;
    //this.isShowAttendaceBtn = false;
    if (!this.AttendanceDetail.IsAttendaceClose || !IsAction) {
      this.utility.GetDateTime().subscribe({
        next: (response) => {
          if (IsAction && !this.AttendanceDetail.IsCheckIn) {
            this.AttendanceDetail.AttendanceDate = (moment(response.Current_Date).year() + '-' + (moment(response.Current_Date).month() + 1) + '-' + moment(response.Current_Date).date()).toString();
          } else {
            this.AttendanceDetail.AttendanceDate = (moment(this.AttendanceDetail.InTime).year() + '-' + (moment(this.AttendanceDetail.InTime).month() + 1) + '-' + moment(this.AttendanceDetail.InTime).date()).toString();
          }
          // this.CurrentTime = moment(response.Current_Date);
          if (!this.AttendanceDetail.IsCheckIn && IsAction) {
            // this.CheckIn();
          } else if (this.AttendanceDetail.IsCheckIn && IsAction) {
            //this.CheckOut();
          } else if (this.AttendanceDetail.IsCheckIn && !IsAction) {
            //this.CheckInStart(this.AttendanceDetail.InTime, true);
          } else {
            //this.isShowAttendaceBtn = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: 'Attendace not allowed for today.', type: toastTypeEnum.danger });
    }
  }

  GetDailyAttendanceInOutDetail(id: number) {
    if (id > 0) {
      this.isDisabled = true;
      this.attendance.GetDailyAttendanceInOut({ DailyAttendanceInOutID: id, SelectType: 2, EmpMasterId: this.InputData.EmpmasterID, FromDate: null, ToDate: null, ApprovalStatus: 'ALL' }).subscribe({
        next: (response) => {
          if (response.toString() != '') {
            this.CalendarDetailsData.id = id;
            this.CalendarDetailsData.Photo = response[0].Photo;
            this.CalendarDetailsData.EmployeeName = response[0].EmployeeName;
            this.CalendarDetailsData.EmpCode = response[0].EmpCode;
            this.CalendarDetailsData.DesignationName = response[0].DesignationName;
            this.CalendarDetailsData.AttendanceDate = (response[0].AttendanceDate != null && response[0].AttendanceDate != "") ? this.dateFromat.parse(response[0].AttendanceDate.split("-")[2] + " " + this.dateFromat.month[parseInt(response[0].AttendanceDate.split("-")[1]) - 1] + " " + response[0].AttendanceDate.split("-")[0]) : '';
            this.CalendarDetailsData.InTime = response[0].InTime;
            this.CalendarDetailsData.OutTime = response[0].OutTime;
            this.CalendarDetailsData.ShiftTitle = response[0].ShiftTitle;
            this.CalendarDetailsData.Remark = response[0].Remark;
            this.CalendarDetailsData.DailyAttendancePhoto = this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["DailyAttendancePhoto"];
            this.CalendarDetailsData.DailyAttendancePhotoOut = this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["DailyAttendancePhotoOut"];
            this.CalendarDetailsData.InReason = (this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["InReason"] != null && this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["InReason"] != "") ? this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["InReason"].split("-")[1] : "";
            this.CalendarDetailsData.OutReason = (this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["OutReason"] != null && this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["OutReason"] != "") ? this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["OutReason"].split("-")[1] : "";
            this.CalendarDetailsData.AttendanceDescription = (this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["AttendanceDescription"] != null && this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["AttendanceDescription"] != "") ? this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["AttendanceDescription"].split(':')[1] : '';
          } else {
            this.CalendarDetailsData.id = 0;
            this.CalendarDetailsData.Photo = this.InputData.Photo;
            this.CalendarDetailsData.EmployeeName = this.InputData.EmpName;
            this.CalendarDetailsData.EmpCode = this.InputData.EmpCode;
            this.CalendarDetailsData.DesignationName = this.InputData.DesignationName;
            this.CalendarDetailsData.AttendanceDate = this.filter.AttendanceDate;
            this.CalendarDetailsData.InTime = null;
            this.CalendarDetailsData.OutTime = null;
            this.CalendarDetailsData.ShiftTitle = null;
            this.CalendarDetailsData.Remark = null;
            this.CalendarDetailsData.DailyAttendancePhoto = null;
            this.CalendarDetailsData.DailyAttendancePhotoOut = null;
            this.CalendarDetailsData.InReason = null;
            this.CalendarDetailsData.OutReason = null;
            this.CalendarDetailsData.AttendanceDescription = null;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.CalendarDetailsData.id = 0;
      this.CalendarDetailsData.Photo = this.InputData.Photo;
      this.CalendarDetailsData.EmployeeName = this.InputData.EmpName;
      this.CalendarDetailsData.EmpCode = this.InputData.EmpCode;
      this.CalendarDetailsData.DesignationName = this.InputData.DesignationName;
      this.CalendarDetailsData.AttendanceDate = this.filter.AttendanceDate;
      this.CalendarDetailsData.InTime = null;
      this.CalendarDetailsData.OutTime = null;
      this.CalendarDetailsData.ShiftTitle = null;
      this.CalendarDetailsData.Remark = null;
      this.CalendarDetailsData.DailyAttendancePhoto = null;
      this.CalendarDetailsData.DailyAttendancePhotoOut = null;
      this.CalendarDetailsData.InReason = null;
      this.CalendarDetailsData.OutReason = null;
      this.CalendarDetailsData.AttendanceDescription = null;
    }
  }


  GetDailyAttendanceInOut() {
    this.isDisabled = true;
    this.attendance.GetDailyAttendanceInOut({ SelectType: 1, EmpMasterId: this.InputData.EmpmasterID, MonthName: this.dateFromat.fullmonth[this.ToDayDate.month - 1], YearName: this.ToDayDate.year }).subscribe({
      next: (response) => {
        if (response.toString() != '') {
          this.AttendanceDetail = response[0];
          this.AttendanceDetail.SelectType = 'InsertUpdate';
          //this.AttendanceDetail.InTime = null;
          //this.AttendanceDetail.OutTime = null;
          if (moment(response[0].AttendanceDate).isSame(this.dateFromat.format(this.ToDayDate))) {
            if (response[0].InTime != null && response[0].OutTime == null) {
              this.AttendanceDetail.IsCheckIn = true;
              this.AttendanceDetail.InTime = moment(response[0].InTime);
              this.GetDateTime(false);
            } else if (response[0].InTime != null && response[0].OutTime != null) {
              this.AttendanceDetail.IsAttendaceClose = true;
              this.AttendanceDetail.IsCheckIn = false;
              this.AttendanceDetail.InTime = moment(response[0].InTime);
              this.AttendanceDetail.OutTime = moment(response[0].OutTime);
              this.CalculateTimeDifference();
              this.GetDateTime(false);
            } else {
              this.AttendanceDetail.InTime = null;
              this.AttendanceDetail.OutTime = null;
              //this.isShowAttendaceBtn = true;
            }
          } else {
            if (response[0].InTime != null && response[0].OutTime == null) {
              this.AttendanceDetail.IsCheckIn = true;
              this.AttendanceDetail.InTime = moment(response[0].InTime);
              this.GetDateTime(false);
            } else if (response[0].InTime != null && response[0].OutTime != null) {
              this.AttendanceDetail.InTime = null;
              this.AttendanceDetail.OutTime = null;
              this.GetDateTime(false);
            } else {
              this.AttendanceDetail.InTime = null;
              this.AttendanceDetail.OutTime = null;
              //this.isShowAttendaceBtn = true;
            }
          }
        } else {
          //this.isShowAttendaceBtn = true;
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  CalculateTimeDifference() {
    const startTime = this.AttendanceDetail.InTime;
    const endTime = this.AttendanceDetail.OutTime;
    const diff = endTime - startTime;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    this.Duration = `${hours}h ${minutes}m ${seconds}s`;
  }
  getDayDotStyle(date: NgbDate): any {
    const currentDate = new Date(date.year, date.month - 1, date.day);
    const matchingEvent = this.calendarData.find(event =>
      new Date(event.AttendanceDate).toDateString() === currentDate.toDateString()
    );

    if (matchingEvent) {
      const baseColor = matchingEvent.Color;
      const backgroundColor = baseColor;

      return {
        'background-color': backgroundColor
      };
    } else {
      return {};
    }
  }

  getDayStyle(date: NgbDate): any {
    // const currentDate = new Date(date.year, date.month - 1, date.day);
    // const matchingEvent = this.calendarData.find(event =>
    //   new Date(event.InTime).toDateString() === currentDate.toDateString()
    // );
    if (date.year === this.ToDayDate.year && date.month === this.ToDayDate.month && date.day === this.ToDayDate.day) {
      // return {
      //   'background-color': '#0078d4af',
      //   'color': 'white',
      //   'padding': '2px'
      // };
      return {};
    } else if (date.year === this.filter.AttendanceDate.year && date.month === this.filter.AttendanceDate.month && date.day === this.filter.AttendanceDate.day) {
      return {
        'background-color': '#0078D4',
        'color': 'white',
        'border-radius': '.25rem'
      };
    }
    else {
      return {};
    }
  }
  Close() {
    this.activeModal.close();
  }

  calculateTotalDuration(startTime: any, endTime: any): string {
    if (startTime !== null && endTime !== null) {
      const [startHours, startMinutes, startSeconds] = startTime.split(':').map(Number);
      const [endHours, endMinutes, endSeconds] = endTime.split(':').map(Number);

      const now = new Date();

      const start = new Date(now);
      start.setHours(startHours, startMinutes, startSeconds, 0);

      const end = new Date(now);
      end.setHours(endHours, endMinutes, endSeconds, 0);

      // Handle next day case
      if (end < start) {
        end.setDate(end.getDate() + 1);
      }

      const diffMs = end.getTime() - start.getTime();
      const totalMinutes = Math.floor(diffMs / (1000 * 60));
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      // Pad with zero if needed (e.g., "02:05")
      const formatted = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      return formatted;
    }
    return '';
  }
}
